import React from 'react';
import BaseLayout from '../../layouts/BaseLayout';
import DashboardStats from './components/DashboardStats';
import TaskList from './components/TaskList';
import PerformanceMetrics from './components/PerformanceChart';
import ActivityFeed from './components/ActivityFeed';
import EventsList from './components/EventList';

function Dashboard() {
  return (
    <BaseLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Employee Dashboard</h1>
          <p className="text-gray-600 mt-1">Track your performance, tasks, and team activities</p>
        </div>
        
        <DashboardStats />
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <TaskList />
          </div>
          <div>
            <PerformanceMetrics />
          </div>
        </div>

        {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ActivityFeed />
          <EventsList />
        </div> */}
      </div>
    </BaseLayout>
  );
}

export default Dashboard;